import * as types from "../../actions/actionTypes";
const initialData = {
  data: [],
  meta: {}
};
const initialState = {
  error: "",
  loading: true,
  data: initialData,
  allPagesData: [],
  allPagesLoading: true,
  allPagesError: ""
};

const ManagerContactReport = (state = initialState, action) => {
  switch (action.type) {
    case types.MANAGER_GET_CONTACT_SUMMARY_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
        data: action.pageNumber ? state.data : initialData
      };
    case types.MANAGER_GET_CONTACT_SUMMARY_SUCCESS:
      const { data, ...meta } = action.payLoad.data;
      return { ...state, loading: false, data: { data, meta } };
    case types.MANAGER_GET_CONTACT_SUMMARY_FAILURE:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

export default ManagerContactReport;
